module.exports = __webpack_public_path__ + "static/media/abstract.f324f45f.jpeg";